<template>
  <div id="meet-the-team">
    <section id="about-us">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">
          {{ $i18n.t("headings.meetTheTeam") }}
        </h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row class="pt-6" justify="center">
          <v-col cols="12" md="6">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img
                :src="members[$vuetify.breakpoint.smAndDown ? 3 : 0].avatar"
              ></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">
              {{ members[$vuetify.breakpoint.smAndDown ? 3 : 0].name }}
            </h2>
            {{ members[$vuetify.breakpoint.smAndDown ? 3 : 0].role }}
          </v-col>
          <v-col cols="12" md="6">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img :src="members[1].avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ members[1].name }}</h2>
            {{ members[1].role }}
          </v-col>
          <v-col cols="12" md="4">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img :src="members[2].avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ members[2].name }}</h2>
            {{ members[2].role }}
          </v-col>
          <v-col cols="12" md="4">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img
                :src="members[$vuetify.breakpoint.smAndDown ? 0 : 3].avatar"
              ></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">
              {{ members[$vuetify.breakpoint.smAndDown ? 0 : 3].name }}
            </h2>
            {{ members[$vuetify.breakpoint.smAndDown ? 0 : 3].role }}
          </v-col>
          <v-col cols="12" md="4">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img :src="members[4].avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ members[4].name }}</h2>
            {{ members[4].role }}
          </v-col>
          <v-col cols="12" md="6">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img :src="members[5].avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ members[5].name }}</h2>
            {{ members[5].role }}
          </v-col>
          <v-col cols="12" md="6">
            <v-avatar class="elevation-12 mb-12" size="300">
              <v-img :src="members[6].avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ members[6].name }}</h2>
            {{ members[6].role }}
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>
  </div>
</template>

<script lang="ts">
export default {
  name: "MeetTheTeamView",
  data: () => ({
    members: [
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2.jpg"),
        name: "Nize Viveiros",
        role: "Quality Controller Foundation Phase",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-1.jpg"),
        name: "Anine Botha",
        role: "Quality Controller Intermediate Phase",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-3.jpg"),
        name: "Karla Loubser",
        role: "Content Creator",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-1.jpg"),
        name: "Anri Dempers",
        role: "Founder & Owner",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-4.jpg"),
        name: "Marina Saayman",
        role: "Administrative Officer",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-3.jpg"),
        name: "Johan Du Preez",
        role: "Full Stack Developer",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-2.jpg"),
        name: "Christo Du Preez",
        role: "Lead Developer",
      },
    ],
  }),
};
</script>
